import { CircularProgress, TableCell, TableRow } from "@mui/material";
import { Box } from "@mui/system";
import MUIDataTable from "mui-datatables";
import React, { useContext, useEffect, useState } from "react";
import CourseAssignmentContext from "../../context/500/CourseAssignmentContext";
import CourseTableCourseOffering from "./CourseTableCourseOffering";
import CourseAllocationComponentForOwn from "./CourseAllocationComponentForOwn";
import SendBackToReqCourses from "./SendBackToReqCourses";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import RemoveOffBatch from "./RemoveOffBatch";

function CourseComponent({ setalertselfassignFailed }) {
  let [loading, setLoading] = useState(false);
  let [courses, setCourses] = useState([]);
  let [courseData, setcourseData] = useState([]);
  let [notownedcourse, setnotownedcourse] = useState([]);
  let [showOptiontosendback, setshowOptiontosendback] = useState(false);
  let [coursetosendBack, setcoursetosendBack] = useState({});
  let [isMounted, setIsMounted] = useState(true);
  let [showremovetab, setshowremovetab] = useState(false);
  let [courestoremove, setcoursetoremove] = useState({});

  let { setError, setoffbatchcourses, offbatchcourses } = useContext(
    CourseAssignmentContext
  );

  const api = useAxiosPrivate();

  const columns = [
    {
      name: "Course Name",
      options: {
        filter: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <span
              style={{ cursor: "pointer" }}
              onDoubleClick={(e) => {
                checkownedCourse(value, e);
              }}
              onContextMenu={(e) => {
                checkoffbatchCourse(value, e);
              }} 
            >
              {value}
            </span>
          );
        },
      },
    },
    {
      name: "Code",
      options: {
        filter: false,
      },
    },
    {
      name: "Cr.Hr",
      options: {
        filter: true,
      },
    },
    {
      name: "LEH",
      options: {
        filter: true,
      },
    }, //for filter of batch on front end
    {
      name: "Batch",
      options: {
        filter: true,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "Admission Type",
      options: {
        filter: true,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "Program Type",
      options: {
        filter: true,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "Department",
      options: {
        filter: true,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "Is OffBatch",
      options: {
        filter: true,
        display: false,
        viewColumns: false,
      },
    },
  ];

  let getCourses = async (signal) => {
    try {
      let respdata = await api.get(
        `courseallocation/allcurrentsemesterOwnedcourse`,
        {
          signal,
        }
      );

      isMounted && setCourses(respdata.data);
    } catch (err) {
      setError(err.response.data.msg);
    }
  };

  function alignCoursesData() {
    let arr = [];
    let notowned = [];
    let offbatchcourses = [];
    courses.forEach((course) => {
      if (course.owned == "Not Owned") {
        notowned.push(course);
      }
      if (course.isOffBatch == "True") {
        offbatchcourses.push(course);
      }
      let LEH = course.lab + course.lecture + course.advisory + course.tutorial;
      let arrfordata = [
        course.course_name,
        course.course_code,
        course.credit_hr,
        LEH,
        course.batch, //for filter of batch on front end
        course.admission_type,
        course.program_type,
        course.owned,
        course.isOffBatch,
      ];

      arr.push(arrfordata);
    });

    setcourseData(arr);
    setnotownedcourse(notowned);
    setoffbatchcourses(offbatchcourses);
  }

  function checkownedCourse(coursename, e) {
    e.preventDefault();

    notownedcourse.forEach((course) => {
      if (coursename == course.course_name) {
        setshowOptiontosendback(true);
        setcoursetosendBack(course);
        return;
      }
    });
  }
  function checkoffbatchCourse(coursename, e) {
    e.preventDefault();

    offbatchcourses.forEach((course) => {
      if (coursename == course.course_name) {
        setshowremovetab(true);
        setcoursetoremove(course);
        return;
      }
    });
  }

  useEffect(() => {
    setIsMounted(true);
    const controller = new AbortController();
    getCourses(controller.signal);

    return () => {
      setIsMounted(false);
      controller.abort();
    };
  }, []);

  useEffect(() => {
    alignCoursesData();
  }, [courses]);

  const options = {
    print: "false",
    download: "false",
    selectableRows: "none",
    filterType: "dropdown",
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 15],
    pagination: true,
    responsive: "vertical",
    expandableRows: true,

    renderExpandableRow: (rowData, rowMeta) => {
      let currentcourse = courses.filter(
        (course) => course.course_code == rowData[1]
      );
      const colSpan = rowData.length - 3;

      return (
        <React.Fragment>
          <TableRow sx={{ padding: "0px" }}>
            <TableCell colSpan={colSpan}>
              <CourseTableCourseOffering cID={rowData[1]} />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell colSpan={colSpan}>
              <CourseAllocationComponentForOwn courseCode={rowData[1]} />
            </TableCell>
          </TableRow>
        </React.Fragment>
      );
    },
  };

  return (
    <div className="CourseTableWrapper">
      {loading == false ? (
        <React.Fragment>
          <MUIDataTable
            data-testId="ownCourseTable"
            title={"Course List"}
            data={courseData}
            columns={columns}
            options={options}
          />

          {showOptiontosendback == true && (
            <SendBackToReqCourses
              getCourses={getCourses}
              course={coursetosendBack}
              setshowOptiontosendback={setshowOptiontosendback}
              setalertselfassignFailed={setalertselfassignFailed}
            />
          )}

          {showremovetab == true && (
            <RemoveOffBatch
              getCourses={getCourses}
              course={courestoremove}
              setshowremovetab={setshowremovetab}
            />
          )}
        </React.Fragment>
      ) : (
        <CircularProgress />
      )}
    </div>
  );
}

export default CourseComponent;
